export type VoicemailDetectionPatterns = Record<string, Record<string, string[]>>;

const TIER_KEY_REGEX = /^tier_(\d+)$/;

export const sortTierKeys = (keys: string[]): string[] =>
  [...keys].sort((a, b) => {
    const matchA = TIER_KEY_REGEX.exec(a);
    const matchB = TIER_KEY_REGEX.exec(b);
    if (matchA && matchB) return Number(matchA[1]) - Number(matchB[1]);
    if (matchA) return -1;
    if (matchB) return 1;
    return a.localeCompare(b);
  });

export const nextTierKey = (tiers: Record<string, string[]>): string => {
  const tierNumbers = Object.keys(tiers)
    .map(k => TIER_KEY_REGEX.exec(k))
    .filter(Boolean)
    .map(m => Number(m![1]));
  const max = tierNumbers.length > 0 ? Math.max(...tierNumbers) : 0;
  return `tier_${max + 1}`;
};

export const languagePatternsHaveContent = (
  langPatterns: Record<string, string[]> | undefined
): boolean => {
  if (!langPatterns) return false;
  return Object.values(langPatterns).some(strings =>
    strings.some(s => s.trim() !== '')
  );
};

export const sanitizePatternsForApi = (
  patterns: VoicemailDetectionPatterns | undefined
): VoicemailDetectionPatterns | undefined => {
  if (!patterns) return undefined;

  const sanitized: VoicemailDetectionPatterns = {};

  for (const [lang, tiers] of Object.entries(patterns)) {
    const sanitizedTiers: Record<string, string[]> = {};

    for (const [tier, strings] of Object.entries(tiers)) {
      const nonEmpty = strings.map(s => s.trim()).filter(s => s !== '');
      if (nonEmpty.length > 0) {
        sanitizedTiers[tier] = nonEmpty;
      }
    }

    if (Object.keys(sanitizedTiers).length > 0) {
      sanitized[lang] = sanitizedTiers;
    }
  }

  return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
